import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from 'features/incidents/components/enums'
import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'

export const activatePatchService = (data: object) => {
  return axios.post(endpoints.activatePatchService, data)
}
export const useActivatePatchService = () => {
  const queryClient = useQueryClient()
  return useMutation(activatePatchService, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.policies, ApiKey.list])
    },
  })
}
